import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { SnackIconSet, ISnackbarData } from 'src/app/types';


@Component({
    selector: 'app-snack-bar',
    templateUrl: './snack-bar.component.html',
    styleUrls: ['./snack-bar.component.scss'],
    standalone: false
})
export class SnackBarComponent {
    toast_icon: string = SnackIconSet.info
    icon_label: string = 'Info icon'
    show: any = {}

    constructor(
        public sbRef: MatSnackBarRef<SnackBarComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: ISnackbarData
    ) {
        const { snack_type } = data

        if (snack_type === SnackIconSet.error) {
            this.toast_icon = SnackIconSet.error
            this.icon_label = 'Error icon'
        } else if (snack_type === SnackIconSet.success) {
            this.toast_icon = SnackIconSet.success
            this.icon_label = 'Success icon'
        } else {
            this.toast_icon = SnackIconSet.info
            this.icon_label = 'Info icon'
        }
    }


    dismiss() {
        this.sbRef.dismiss()
    }
}
